export enum InProductTrialCannotBeStartedReason {
  AlreadyStartedForCurrentProduct = 1,
  AlreadyStartedForAnotherProduct = 2,
  CoolDownNotPassedForStart = 3,
  NotEnoughDaysForCurrentProduct = 4,
  CoolDownNotPassedForRequest = 5,
}

export const CoolDownPeriodMonths = 6;
